module.exports = __webpack_public_path__ + "img/OI_blue.69d768a4.svg";